export const APP_ID = "BKRS";
